import * as Yup from 'yup';
import { PaymentsEftRecordStatus, PaymentsEftRecordType } from '../models/DeprecatedEnums';

export class PaymentValidations {
  public static changeEftRecordStatusValidation() {
    return Yup.object().shape({
      status: Yup.string().oneOf([PaymentsEftRecordStatus.PENDING, PaymentsEftRecordStatus.IGNORE, PaymentsEftRecordStatus.DUPLICATE])
    });
  }

  public static changeEftRecordTypeValidation() {
    return Yup.object().shape({
      type: Yup.string().oneOf([
        PaymentsEftRecordType.EFT,
        PaymentsEftRecordType.SWIFT,
        PaymentsEftRecordType.CASH,
        PaymentsEftRecordType.FEE,
        PaymentsEftRecordType.OTHER
      ])
    });
  }
}
